import type { ReactNode } from "react";
import { useSchoolLocal } from "../useSchoolLocal";

type SchoolSectionProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

export const SchoolSection = ({
  children,
  className = "",
  contentClassName = "",
}: SchoolSectionProps) => {
  const { dir, bodyFont } = useSchoolLocal();

  return (
    <section
      dir={dir}
      className={`w-full text-[#2E2E38] ${bodyFont} ${className}`}
    >
      <div className={`mx-auto max-w-[1200px] px-6 ${contentClassName}`}>
        {children}
      </div>
    </section>
  );
};
